import { useCallback } from 'react'
import { Keyboard } from 'react-native'
import { useRouter } from 'expo-router'
import { ReduceMotion } from 'react-native-reanimated'
import BottomSheet, { BottomSheetBackdrop } from '@gorhom/bottom-sheet'

import { DS } from '@/design-system'
import { styles } from '@/components/JoinGameSheet/styles'
import { isWeb, useMaxWidth } from '@/components/WebWrapper'
import JoinLiveGameSheetContent from '@/components/JoinLiveGameSheet/JoinLiveGameSheetContent'

export const JoinLiveGameSheet = () => {
  const router = useRouter()
  const maxWidth = useMaxWidth()

  const onClose = useCallback(() => {
    if (router.canDismiss()) {
      return router.dismiss()
    }
    router.dismissTo('/(root)/(tabs)/play')
  }, [router])

  const renderBackdrop = useCallback(
    (props: React.ComponentProps<typeof BottomSheetBackdrop>) => (
      <BottomSheetBackdrop
        {...props}
        pressBehavior={'close'}
        disappearsOnIndex={-1}
        appearsOnIndex={0}
        onPress={() => {
          requestAnimationFrame(() => {
            Keyboard.dismiss()
          })
        }}
      />
    ),
    []
  )

  return (
    <BottomSheet
      index={0}
      enableDynamicSizing={true}
      maxDynamicContentSize={500}
      onClose={onClose}
      enableContentPanningGesture
      enableHandlePanningGesture
      enablePanDownToClose
      keyboardBlurBehavior="restore"
      detached={false}
      handleStyle={styles.bottomSheetHandleStyle}
      handleIndicatorStyle={styles.bottomSheetIndicatorStyle}
      backgroundStyle={{ backgroundColor: DS.palette['Brand/Cream'] }}
      backdropComponent={renderBackdrop}
      overrideReduceMotion={ReduceMotion.System}
      style={{
        marginBottom: 64,
        marginHorizontal: isWeb ? 'auto' : undefined,
        maxWidth: maxWidth,
        width: '100%'
      }}
    >
      <JoinLiveGameSheetContent />
    </BottomSheet>
  )
}
